import { organizationType } from "const/nuclias/organization";
import { iconType } from "../Headers/const";
import { userType } from 'const/nuclias/user';
import { PATH } from "router/config/const";

import store from "stores";
import { selectOrgLevel } from "stores/slice/pageContext";
import { pageContextActions } from "stores/slice/pageContext";

import { isNil, cloneDeep, orderBy } from 'lodash';

const initTagOption = () => {
  const { pageContext } = store.getState();
  let tmpList = [];
  if (pageContext.selectedOrg) {

    for (const [tagId, tagItem] of Object.entries(pageContext.selectedOrg.storeTagObj)) {
      const tmp = {
        name: tagItem.name,
        id: tagItem.id,
        type: organizationType.tag,
      };
      tmpList.push(tmp);
    }
  }

  return orderBy(tmpList, [item => item.name.toLowerCase()], 'asc')
};

const initSiteOption = () => {
  const { pageContext, user } = store.getState();
  let tmpList = [];
  if (pageContext.selectedStoreTag && user.user.type !== userType.siteTag) {
    for (const [storeId, storeItem] of Object.entries(pageContext.selectedStoreTag.storeObj)) {
      const tmp = {
        name: storeItem.name,
        id: storeItem.id,
        type: organizationType.site,
      };
      tmpList.push(tmp);
    }
  } else if (pageContext.selectedOrg) {
    for (const [storeId, storeItem] of Object.entries(pageContext.selectedOrg.storeObj)) {
      const tmp = {
        name: storeItem.name,
        id: storeItem.id,
        type: organizationType.site,
      };
      tmpList.push(tmp);
    }
  }
  return orderBy(tmpList, [item => item.name.toLowerCase()], 'asc')
};

const initTargetOrg = () => {
  const selectedOrg = store.getState().pageContext.selectedOrg;
  const editObj = {
    icon: iconType.org
  };
  editObj.name = selectedOrg.name;
  editObj.id = selectedOrg.id;
  return editObj;
};

const setTargetSite = () => {
  const pageContext = store.getState().pageContext;
  const editObj = {};
  if (pageContext.selectedStore) {
    editObj.icon = iconType.site;
    editObj.name = pageContext.selectedStore.name;
    editObj.id = pageContext.selectedStore.id;
    editObj.type = organizationType.site;
  } else if (pageContext.selectedStoreTag) {
    editObj.icon = iconType.tag;
    editObj.name = pageContext.selectedStoreTag.name;
    editObj.id = pageContext.selectedStoreTag.id;
    editObj.type = organizationType.tag;
  } else {
    editObj.icon = null;
    editObj.name = 'b1c94ca2fb';
    editObj.id = null;
    editObj.type = null;
  }
  return editObj;
};

const changeSite = async (item) => {
  try {
    const pageContext = store.getState().pageContext;
    const data = {};
    if (!isNil(item)) {
      if (item.type === organizationType.tag) {
        const selectedTag = cloneDeep(pageContext.selectedOrg.storeTagObj[item.id]);
        const { storeTagObj, storeObj } = await expandChildren(selectedTag);
        selectedTag.storeTagObj = storeTagObj;
        selectedTag.storeObj = storeObj;
        data.selectedStoreTag = selectedTag;
        data.selectedStore = null;
      } else {
        data.selectedStore = pageContext.selectedOrg.storeObj[item.id];
      }
    } else {
      data.selectedStoreTag = null;
      data.selectedStore = null;
    }
    store.dispatch(pageContextActions.setAll(data));
    // return data;
  } catch (error) {
    console.error(`Change site failed: ${error}`);
  }

};

const expandChildren = (selectedTag) => {
  return new Promise((Resolve, reject) => {
    const storeObj = {};
    const storeTagObj = {};
    const insertStore = (stores, parentTagId) => {
      for (const store of stores) {
        const tmpStore = Object.assign({}, store);
        tmpStore.parentStoreTagId = parentTagId;
        storeObj[tmpStore.id] = tmpStore;
      }
    };

    const insertStoreTag = (tags, parentTagId) => {
      for (const tag of tags) {
        const tmpTag = Object.assign({}, tag);
        insertStoreTag(tag.storeTags, tag.id);
        insertStore(tag.stores, tag.id);

        tmpTag.parentStoreTagId = parentTagId;
        storeTagObj[tmpTag.id] = tmpTag;
      }
    };
    insertStoreTag(selectedTag.storeTags, null);
    insertStore(selectedTag.stores, null);

    Resolve({ storeTagObj, storeObj });
  });
};

const getHomeUrl = () => { // ready~~~
  const getStore = store.getState();
  const { user } = getStore;
  const orgLevel = selectOrgLevel(getStore);
  if (user?.user?.type === userType.sp) {
    return PATH.dashboard.dashboard; ///settings/organization
  } else if (user?.user?.type === userType.si && orgLevel === organizationType.si) {
    return PATH.dashboard.dashboard; ///dashboard/network-view
  }
  return PATH.dashboard.dashboard;
};

export default {
  initTargetOrg,
  setTargetSite,
  initTagOption,
  initSiteOption,
  changeSite,
  getHomeUrl,
};